import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanyComment } from 'app/modules/coordinator/entities/company-comment';
import { CoordinatorStatisticsService } from 'app/modules/coordinator/services/coordinator-statistics.service';
import { EmpresaTreeViewService } from 'app/modules/employee/services/empresa-treeView.service';
import { CommentPopupComponent } from './comment-popup/comment-popup.component';

@Component({
    selector: 'app-company-comments',
    templateUrl: './company-comments.component.html',
    styleUrls: ['./company-comments.component.scss'],
    standalone: false
})
export class CompanyCommentsComponent implements OnInit {

  public selectedCompanyId = 0;
  public isLoading = true;
  public commentData: CompanyComment;

  constructor(
    private empresaTreeViewService: EmpresaTreeViewService,
    private coordinatorStatisticsService: CoordinatorStatisticsService,
    private sharedService: SharedService,
    private dialog: MatDialog) {
    this.registerTreeViewListener();
  }

  ngOnInit(): void {
    this.selectedCompanyId = JSON.parse(localStorage.getItem('Empresa'));
    if (this.selectedCompanyId > 0) {
      this.getCommentData();
    }
  }

  private registerTreeViewListener(): void {
    this.empresaTreeViewService.EmpId.subscribe(res => {
      this.selectedCompanyId = res;
      if (this.selectedCompanyId > 0 && !this.coordinatorStatisticsService.isStatisticsHidden) {
        this.getCommentData();
      }
    });
  }

  private getCommentData(): void {
    this.isLoading = true;
    this.coordinatorStatisticsService.GetCommentData(String(this.selectedCompanyId)).subscribe(res => {
      if (res.code === 0) {
        this.commentData = res.result;
      } else {
        this.sharedService.ShowSnackBar('No pudo cargar los comentarios de la empresa.');
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

  public showCommentPopup() {
    const modalRef = this.dialog.open(CommentPopupComponent, {
      width: '400px',
    });

    modalRef.componentInstance.commentData = this.commentData;
  }

}
